import React from "react";
import ProjectCard from "./ProjectCard";
import img1 from "../assets/images/project/img1.webp";
import img2 from "../assets/images/project/img2.webp";
import eventixImg from "../assets/images/project/eventix.webp";
import img5 from "../assets/images/project/img5.webp";
import img8 from "../assets/images/project/img8.webp";


const ProjectSection = () => {
    const projects = [
        {
            id: 1,
            title: "ContactHQ",
            category: "AI Form Builder / SaaS",
            link: "https://contacthq.in/",
            image: img1,
            buttonText: "Explore SaaS",
            delay: "reveal-delay-1"
        },
        {
            id: 2,
            title: "Eventix",
            category: "Event Management / SaaS",
            link: "http://eventix.in/",
            image: eventixImg,
            buttonText: "Visit Platform",
            delay: "reveal-delay-2"
        },
        {
            id: 3,
            title: "New Unity Jewellers",
            category: "Luxury Retail / E-commerce",
            link: "https://newsunityjewellers.in/",
            image: img5,
            buttonText: "Visit Store",
            delay: "reveal-delay-1"
        },
        {
            id: 4,
            title: "Elora Global Holidays",
            category: "Travel & Tour Booking",
            link: "https://eloraglobalholidays.com/",
            image: img8,
            buttonText: "Book Now",
            delay: "reveal-delay-4"
        },
    ];

    return (
        <section
            id="projects"
            className="py-24 bg-white dark:bg-surface-dark border-b border-gray-100 dark:border-gray-800 scroll-mt-20 overflow-hidden"
        >
            <div className="w-[90%] mx-auto">
                <div className="flex flex-col items-center text-center mb-16">
                    <div className="reveal inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-bold uppercase tracking-widest font-display">
                        <span className="relative flex h-2 w-2">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
                        </span>
                        Featured Works
                    </div>
                    <h2 className="reveal reveal-delay-1 text-4xl md:text-5xl font-bold text-[#0d121b] dark:text-white mt-6 font-display tracking-tight">
                        Recent Projects
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {projects.map((project) => (
                        <ProjectCard key={project.id} project={project} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ProjectSection;